import { setEnvironment } from '../environment';

export const environment = setEnvironment({
  APPLICATION_NAME: 'DSMNext',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: 'redirect',
  SIGNUP_SIGNIN_POLICY: 'B2C_1A_AllAccountsSignupSignin',
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'DairyStartMonitor',
  APP_INSIGHTS_KEY: '',
  DEFAULT_LOCALE: 'nl-NL',
  LOCALES: 'nl-NL,en-US',
  PRODUCTION: 'false',
  RELATIONSHIPS_ELASTIC_SEARCH: 'true',
  APIM_BASE_URL: 'http://localhost:4200/external',
  USE_NEW_NOTIFICATIONS: 'true',
  IS_MY_PROSPECTS_HIDDEN: 'true',
});
